import { createUseStyles } from 'react-jss'

export const style = {
  backLink: {
    position: 'fixed',
    top: 0,
    left: 78,
    height: 80,
    display: 'flex',
    alignItems: 'center'
  }
}

export const useStyles = createUseStyles(style)
